module.exports = __webpack_public_path__ + "img/美妆-3.890b6882.png";